/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useMemo, useState, useEffect } from "react";
import { useDracoGLTF } from "../../../../utils/useDracoGLTF";
import { config as springConfig, useTransition } from "@react-spring/three";
import FactsAndFiguresMarker from "../../factsandfigures/FactsAndFiguresMarker";
import { UIPortal } from "@solidwhite/ui-portal";
import PowerrailUI from "../applications/powerrail/PowerrailUI";

export function Airport({ ...props }) {
  const { nodes } = useDracoGLTF("./models/charge/airport_labels.glb");
  const [powerRailState, setPowerRailState] = useState([]);
  const [powerFloorState, setPowerFloorState] = useState([]);
  const [staticChargeState, setStaticChargeState] = useState([]);
  const [dynamicChargeState, setDynamicChargeState] = useState([]);

  const powerrailPositions = useMemo(() => {
    var positions = [];
    nodes["powerrail"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const powerfloorPositions = useMemo(() => {
    var positions = [];
    nodes["powerfloor"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const staticchargePositions = useMemo(() => {
    var positions = [];
    nodes["staticcharge"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const dynamicchargePositions = useMemo(() => {
    var positions = [];
    nodes["dynamiccharge"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const powerrailTransition = useTransition(powerRailState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const powerfloorTransition = useTransition(powerFloorState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const staticchargeTransition = useTransition(staticChargeState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const dynamicchargeTransition = useTransition(dynamicChargeState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const powerrail = powerrailTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Hardening_${i}`}
        key={`Hardening_${i}`}
        color="#97E58B"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const powerfloor = powerfloorTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Hardening_${i}`}
        key={`Hardening_${i}`}
        color="#F0958B"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const dynamiccharge = dynamicchargeTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Hardening_${i}`}
        key={`Hardening_${i}`}
        color="#F5D07A"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  const staticcharge = staticchargeTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Hardening_${i}`}
        key={`Hardening_${i}`}
        color="#4BA8EF"
        circleSegments={16}
        size={0.03}
        lineHeight={1}
      />
    );
  });

  useEffect(() => {
    setPowerRailState(powerrailPositions);
    setPowerFloorState(powerfloorPositions);
    setDynamicChargeState(dynamicchargePositions);
    setStaticChargeState(staticchargePositions);
  }, []);

  return (
    <group {...props} dispose={null}>
      {powerrail}
      {powerfloor}
      {dynamiccharge}
      {staticcharge}
    </group>
  );
}
